function lastN(s: String, n: number) {
  return s.slice(s.length - n)
}

const prefix = lastN("" + Math.random(), 6)

let id = 0
export function newId(type?: string): string {
  id++
  return "id_" + (type ? type + "_" : "") + prefix + "_" + id
}



// WEBPACK FOOTER //
// ./src/lib/id.ts